import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TaskFilter } from '@utils/models/TaskFilter';

import { TaskDataType, TaskStatusType } from './models';
import { taskModels } from '.';

const initialState: {
  isDragging: boolean;
  activeTask?: TaskFilter;
  startColumn?: TaskStatusType;
  action: Record<string, boolean>;
  data: Record<TaskStatusType, TaskDataType>;
  actionModal: { visible: boolean; type: taskModels.TaskActionStatusType };
} = {
  data: {
    Otib_ketgan: {
      count: 0,
      list: [],
      total: 0
    },
    Bugungi: {
      count: 0,
      list: [],
      total: 0
    },
    Ertangi: {
      count: 0,
      list: [],
      total: 0
    },
    Rejada: {
      count: 0,
      list: [],
      total: 0
    }
  },

  isDragging: false,

  actionModal: {
    visible: false,
    type: 'done'
  },

  action: {
    done: false,
    delete: false,
    lastDay: false,
    lastMonth: false,
    lastMonday: false
  }
};

const taskSlice = createSlice({
  initialState,
  name: 'task-slice',
  reducers: {
    setTaskColumns: (state, action: PayloadAction<Record<TaskStatusType, TaskDataType>>) => {
      state.data = action.payload;
    },
    setTaskColumnData: (
      state,
      action: PayloadAction<{
        key: TaskStatusType;
        data: { list: TaskFilter[]; count: number; total: number };
      }>
    ) => {
      state.data[action.payload.key] = action.payload.data;
    },
    setTaskColumnDataItem: (
      state,
      action: PayloadAction<{
        task: TaskFilter;
        overId: TaskStatusType;
        oldOverId: TaskStatusType;
        activeId: string | number;
      }>
    ) => {
      const { activeId, oldOverId, overId, task } = action.payload;

      if (oldOverId && overId && activeId && oldOverId !== overId) {
        state.data[oldOverId] = {
          ...state.data[oldOverId],
          count: state.data[oldOverId]?.count - 1,
          list: state.data[oldOverId]?.list?.filter(({ id }) => id !== Number(activeId))
        };

        state.data[overId] = {
          total: state.data[overId]?.total,
          count: state.data[overId]?.count + 1,
          list: [...state.data[overId]?.list, task]
        };
      }
    },
    setTaskAction: (
      state,
      actions: PayloadAction<{
        key: string;
        value: boolean;
      }>
    ) => {
      state.action[actions.payload.key] = actions.payload.value;

      Object.keys(state.action).forEach(i => {
        if (i !== actions.payload.key) {
          state.action[i] = false;
        }
      });
    },
    setTaskDragging: (state, actions: PayloadAction<boolean>) => {
      state.isDragging = actions.payload;
    },
    setTaskVisibleAction: (
      state,
      actions: PayloadAction<{ visible: boolean; type: taskModels.TaskActionStatusType }>
    ) => {
      state.actionModal = actions.payload;
    },
    setTaskActiveData: (state, actions: PayloadAction<TaskFilter>) => {
      state.activeTask = actions.payload;
    },
    setTaskStartColumn: (state, actions: PayloadAction<TaskStatusType>) => {
      state.startColumn = actions.payload;
    }
  }
});

export const taskReducer = taskSlice.reducer;

export const {
  setTaskAction,
  setTaskColumns,
  setTaskDragging,
  setTaskColumnData,
  setTaskActiveData,
  setTaskStartColumn,
  setTaskVisibleAction,
  setTaskColumnDataItem
} = taskSlice.actions;
